import React, { useState, useEffect } from "react"
import MetaTags from "react-meta-tags"
import { Link, useHistory } from "react-router-dom"
import { Col, Container, Form, FormGroup, Input, Label, Row } from "reactstrap"
import * as url from "helpers/url_helper"
import SweetAlert from "react-bootstrap-sweetalert"

//i18n
import PropTypes from "prop-types"
import { withTranslation } from "react-i18next"

// import images
import logodark from "../../assets/images/logo-dark.png"
import logolight from "../../assets/images/logo-light.png"
import bgImage from "assets/images/ugifts/loginbg.png"
import { Button } from "@material-ui/core"

const ForgotPassword = props => {
  const history = useHistory()

  const [token, setToken] = useState(null)
  const [countryCode, setCountryCode] = useState("60")
  const [phoneNumber, setPhoneNumber] = useState(null)

  useEffect(() => {
    if (localStorage.getItem("authAPI")) {
      const obj = JSON.parse(localStorage.getItem("authAPI"))
      console.log(
        "storage",
        obj.api_token_expiry + " / " + Math.floor(Date.now() / 1000)
      )
      if (obj.api_token_expiry < Math.floor(Date.now() / 1000)) {
        getToken()
      } else {
        setToken(obj)
      }
    } else {
      getToken()
    }
  }, [])

  const getToken = async () => {
    var urlencoded = new URLSearchParams()
    urlencoded.append("option", "get_api_token")
    urlencoded.append("source", "web")
    urlencoded.append("api_key", process.env.REACT_APP_APIKEY)

    const requestOptions = {
      method: "POST",
      body: urlencoded,
    }

    console.log("Request token", urlencoded.toString())

    const response = await fetch(url.UGIFT_STAGING_POST_AUTH, requestOptions)
    const postresponse = await response.json()

    console.log(response.status, postresponse.message)

    if (response.status == 200 && postresponse.success) {
      setToken(postresponse)
      localStorage.setItem("authAPI", JSON.stringify(postresponse))
      console.log(response.status, token)
    } else {
      // seterror_alert(true)
    }
  }

  const submitForgotPassword = async e => {
    e.preventDefault()
    if (countryCode == null) {
      console.log("country code empty")
      seterror_alert(true)
      setdynamic_title(props.t("Country code empty"))
      setdynamic_description(props.t("Please choose a country code"))
      return
    }

    if (phoneNumber == null) {
      console.log("phone number empty")
      seterror_alert(true)
      setdynamic_title(props.t("Phone number empty"))
      setdynamic_description(props.t("Please enter your phone number"))
      return
    }

    var urlencoded = new URLSearchParams()
    urlencoded.append("option", "get_otp")
    urlencoded.append("action", "forgot_password")
    urlencoded.append("phone_number", countryCode + phoneNumber)

    const requestOptions = {
      method: "POST",
      headers: {
        Authorization: "Bearer " + token.api_token,
      },
      body: urlencoded,
    }

    console.log("Request otp", urlencoded.toString())

    const response = await fetch(
      url.UGIFT_STAGING_POST_AUTH,
      // "http://47.241.176.8/api/external/auth/",
      requestOptions
    )
    const postresponse = await response.json()
    // response.body
    // setPostResponse(postresponse)
    console.log(response.status, postresponse)

    if (response.status == 200 && postresponse.success) {
      if (postresponse.success) {
        localStorage.setItem("OTP", JSON.stringify(postresponse))
        localStorage.setItem("phoneNumber", countryCode + phoneNumber)
        localStorage.setItem("countryCode", countryCode)
        setsuccess_dlg(true)
        setdynamic_title(props.t("OTP Sent"))
        setdynamic_description(postresponse.message)
      }
    } else {
      seterror_alert(true)
      setdynamic_title(props.t("Failed"))
      setdynamic_description(postresponse.message)
    }
  }

  const [countryData, setCountryData] = useState(null)
  const getCountryList = async () => {
    var urlencoded = new URLSearchParams()
    urlencoded.append("option", "list_country")
    urlencoded.append("order_by", "ASC")

    const requestOptions = {
      method: "POST",
      // mode: "no-cors",
      headers: {
        // "Content-Type": "application/json",
        Authorization: "Bearer " + token.api_token,
      },
      body: urlencoded,
    }

    console.log("Request country", urlencoded.toString())

    const response = await fetch(
      url.UGIFT_STAGING_PROFILE,
      // "http://47.241.176.8/api/external/auth/",
      requestOptions
    )
    const postresponse = await response.json()
    // response.body
    // setPostResponse(postresponse)
    console.log(response.status, postresponse)

    if (response.status == 200) {
      // history.push("/tables-applicationtable")
      setCountryData(postresponse.table)
    } else {
      // seterror_alert(true)
    }
  }

  useEffect(() => {
    if (token) {
      getCountryList()
    }
  }, [token])

  function onCountryCodeChange(e) {
    setCountryCode(e.target.value)
  }

  function onPhoneNumberChange(e) {
    setPhoneNumber(e.target.value)
  }

  const [success_dlg, setsuccess_dlg] = useState(false)
  const [success_dlg_noaction, setsuccess_dlg_noaction] = useState(false)
  const [error_alert, seterror_alert] = useState(false)
  const [dynamic_title, setdynamic_title] = useState("")
  const [dynamic_description, setdynamic_description] = useState("")

  return (
    <React.Fragment>
      <div>
        <MetaTags>
          <title>Ugift</title>
        </MetaTags>
        <Container fluid className="p-0">
          <Row className="g-0">
            {/* <CarouselPage /> */}
            {success_dlg_noaction ? (
              <SweetAlert
                success
                title={dynamic_title}
                onConfirm={() => {
                  setsuccess_dlg_noaction(false)
                }}
              >
                {dynamic_description}
              </SweetAlert>
            ) : null}
            {success_dlg ? (
              <SweetAlert
                success
                title={dynamic_title}
                onConfirm={() => {
                  history.push("/forgot-password-verification")
                }}
              >
                {dynamic_description}
              </SweetAlert>
            ) : null}
            {error_alert ? (
              <SweetAlert
                title={dynamic_title}
                danger
                onConfirm={() => {
                  seterror_alert(false)
                }}
              >
                {dynamic_description}
              </SweetAlert>
            ) : null}
            <Col
              xl={6}
              className="mx-auto"
              style={{
                maxWidth: "480px",
                backgroundImage: `url(${bgImage})`,
                backgroundSize: "cover",
              }}
            >
              {/* <img
                src={bgImage}
                alt=""
                style={{
                  position: "absolute",
                  objectFit: "contain",
                  maxWidth: "480px",
                }}
              /> */}
              <div
                className="auth-full-page-content"
                style={{ minHeight: "100vh" }}
              >
                <div className="w-100">
                  <div className="d-flex flex-column h-100">
                    <div className="">
                      <Row
                        className="m-0"
                        style={{ height: "56px", backgroundColor: "#009FE2" }}
                      >
                        <Col xs={2}>
                          <Link to="/login">
                            <Button className="h-100 m-0">
                              <i className="bx bx-arrow-back align-middle font-size-20 me-2 text-white" />
                            </Button>
                          </Link>
                        </Col>
                        <Col xs={8} className="align-self-center">
                          <p className="h-100 text-white font-size-15 my-auto text-center">
                            {props.t("Forgot Password")}
                          </p>
                        </Col>
                        <Col xs={2}></Col>
                      </Row>
                      <div className="mx-3" style={{ marginTop: "300px" }}>
                        <Form>
                          <Row className="mb-3 px-2">
                            {/* <Label className="font-size-15 font-weight-bold">
                              Mobile
                            </Label> */}
                            <Col xs="auto" className="pe-1">
                              <select
                                className="form-control font-size-15"
                                style={{ borderRadius: "8px", border: "none" }}
                                onChange={onCountryCodeChange}
                              >
                                {countryData &&
                                  countryData.map((data, index) => (
                                    <option
                                      value={data.country_code.replace("+", "")}
                                    >
                                      {data.country_code}
                                    </option>
                                  ))}
                              </select>
                            </Col>
                            <Col className="ps-1">
                              <Input
                                type="text"
                                className="form-control font-size-15"
                                id="userMobile"
                                placeholder={props.t("Enter mobile number")}
                                style={{ borderRadius: "8px", border: "none" }}
                                onChange={onPhoneNumberChange}
                              />
                            </Col>
                          </Row>

                          <Row className="mb-3 px-2">
                            <Col>
                              {/* <Link to="/forgot-password-verification">
                                <button
                                  className="btn btn-primary btn-block waves-effect waves-light w-100 font-size-18"
                                  type="submit"
                                  style={{ borderRadius: "8px" }}
                                >
                                  <strong>Get OTP</strong>
                                </button>
                              </Link> */}
                              <button
                                className={
                                  phoneNumber != null && phoneNumber != ""
                                    ? "btn btn-primary btn-block waves-effect waves-light w-100 font-size-18"
                                    : "btn btn-light btn-block waves-effect waves-light w-100 font-size-18 text-muted"
                                }
                                style={{ borderRadius: "8px" }}
                                onClick={submitForgotPassword}
                                disabled={
                                  phoneNumber == null || phoneNumber == ""
                                }
                              >
                                <strong>{props.t("Get OTP")}</strong>
                              </button>
                            </Col>
                          </Row>

                          <Row className="mb-3 px-2">
                            <p
                              className="mb-0 text-center font-size-15"
                              style={{ color: "#000000" }}
                            >
                              {props.t(
                                "We will send you your one-time password (OTP)"
                              )}
                            </p>
                          </Row>
                        </Form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default withTranslation()(ForgotPassword)

ForgotPassword.propTypes = {
  t: PropTypes.any,
}
